var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{attrs:{"fullscreen":"","title":_vm.taskName,"background-color-popup":"#f8f8f8","active":_vm.popupActive},on:{"update:active":function($event){_vm.popupActive=$event}}},[_c('single-task',{ref:"taskPage",on:{"taskLoaded":function($event){_vm.taskName = _vm.$refs.taskPage.taskName}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }